import TheImpossible from "../../../../../public/the-impossible.svg";
import Celebrate from "../../../../../public/celebrate.svg";
import Fix from "../../../../../public/fix.svg";
import PeopleFirst from "../../../../../public/people-first.svg";

export const objectives = [
  {
    title: "Be an owner, not a renter",
    description:
      "We have an ownership mindset, a sense of urgency, and intrinsic motivation to do our best",
    Icon: PeopleFirst
  },
  {
    title: "Forget the instruction manual",
    description:
      "We act with limited guidance, make data driven decisions, and always have a backbone during debate",
    Icon: Fix
  },
  {
    title: "Do the ordinary extraordinarily well",
    description:
      "We are detail oriented, prioritize HH customers, high velocity & horsepower doers.",
    Icon: TheImpossible
  },
  {
    title: "Make things that last",
    description:
      "We have high EQ, understanding of customer needs, team orientations, deep empathy, and self awareness",
    Icon: Celebrate
  }
];
